import { render, staticRenderFns } from "./imenu.vue?vue&type=template&id=12380556&scoped=true&"
import script from "./imenu.vue?vue&type=script&lang=js&"
export * from "./imenu.vue?vue&type=script&lang=js&"
import style0 from "./imenu.vue?vue&type=style&index=0&id=12380556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12380556",
  null
  
)

export default component.exports